module.exports = __webpack_public_path__ + "static/img/more-LOGO-03.0ea915c9.svg";